import { css } from '@emotion/core';
import React, { Component } from "react";
import { Card, Accordion, Button, Form, Row } from "react-bootstrap";
import ReactTable from "react-table";
import { API } from "aws-amplify";
import Moment from "moment";


export default class HybridProofingCategory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: props.id,
            name: props.name,
            description: props.description,
            items: props.items,
            user: props.user,
            allSelected: true
        };
    }

    getSelectedItems() {
        let selectedItemIds = [];

        for (const item of this.state.items) {
            if (item.selected === false) continue;
            const idColumn = Object.entries(item.action_item).find(([_, value]) => value.IsId === true);
            if (!idColumn) continue;
            selectedItemIds.push(idColumn[1].Value);
        }

        return selectedItemIds;
    }

    handleLinkClicked(e) {
        const numSelectedItems = this.getSelectedItems().length;
        const maxAllowedSelectedItems = 1000;

        // If the URL is too long (owing to too many items selected), React will throw a 414.
        // Assumption: 1000 selected items will never result in a URL that is too long.
        // (Seems reasonable; I encountered no 414s during many random selections of 1000 items.)
        if (numSelectedItems > maxAllowedSelectedItems) {
            alert(`Too many queue items selected (${numSelectedItems}).\nPlease keep selection to no more than ${maxAllowedSelectedItems}.`);
            e.preventDefault();
        }
    }

    getTableColumns() {
        console.assert(this.state.items.length > 0, 'Items empty; no actionItems to build a table from');

        const getLinkHref = r => {
            let selectedItemIds = this.getSelectedItems();
            return (selectedItemIds.length > 0) ? `${r.value.HyperlinkUrl}?browselist=${selectedItemIds.join(',')}` : r.value.HyperlinkUrl;
        };
        const getCell = r => (
            (r.value.Type === 'Hyperlink' && r.value.hasOwnProperty('HyperlinkUrl'))
                ? <a target="_blank" rel="noopener noreferrer" href={getLinkHref(r)} onClick={this.handleLinkClicked.bind(this)}>{r.value.Value}</a>
                : <span>{r.value.Value}</span>
        );
        const selectedCheckboxColumn = {
            id: 'selected',
            Header: r => (
                <Form.Check checked={this.state.allSelected}
                    onChange={this.handleAllSelectedCheckbox.bind(this)}
                    type="checkbox"           
                    style={{ textAlign: "center" }}
                />
            ),
            accessor: r => r.selected, 
            Cell: r => (
                <Form.Check checked={r.value}                    
                    onChange={this.handleSelectedCheckbox.bind(this, r)}
                    type="checkbox"           
                    style={{ textAlign: "center" }}
                />
            ),
            style: { 'white-space': 'unset' } ,
            maxWidth: 100
        };
        const actionItemColumns = Object.entries(this.state.items[0].action_item).map(([columnHeader, _]) => ({
            id: columnHeader,
            Header: columnHeader,
            accessor: r => r.action_item[columnHeader], 
            Cell: r => getCell(r),
            style: { 'white-space': 'unset' } ,
            maxWidth: 100
        }));
        const actionedCheckboxColumn = {
            id: 'actioned_date',
            Header: 'Actioned?',
            accessor: r => r.actioned_date, 
            Cell: r => (
                <Form.Check checked={r.value !== null}                    
                    onChange={this.handleActionedCheckbox.bind(this, r)}
                    type="checkbox"           
                    style={{ textAlign: "center" }}
                />
            ),
            style: { 'white-space': 'unset' } ,
            maxWidth: 100
        };
        const actionedByColumn = {
            id: 'actioned_by',
            Header: 'Actioned By',
            accessor: 'actioned_by',
            maxWidth: 100,
        };
        const actionedDateColumn = {
            id: 'actioned_date',
            Header: 'Actioned Date',
            accessor: 'actioned_date',
            Cell: r => ((r.original.actioned_date) ? Moment(r.original.actioned_date).format('DD-MM-YYYY') : ''),
            maxWidth: 100,
        };
        const closedCheckboxColumn = {
            id: 'closed_date',
            Header: 'Closed?',
            accessor: r => r.closed_date, 
            Cell: r => (
                <Form.Check checked={r.value !== null}                    
                    onChange={this.handleClosedCheckbox.bind(this, r)}
                    type="checkbox"
                    style={{ textAlign: "center" }}
                />
            ),
            style: { 'white-space': 'unset' } ,
            maxWidth: 100
        };
        const closedByColumn = {
            id: 'closed_by',
            Header: 'Closed By',
            accessor: 'closed_by',
            maxWidth: 100,
        };
        const closedDateColumn = {
            id: 'closed_date',
            Header: 'Closed Date',
            accessor: 'closed_date',
            Cell: r => ((r.original.closed_date) ? Moment(r.original.closed_date).format('DD-MM-YYYY') : ''),
            maxWidth: 100,
        };

        return [selectedCheckboxColumn, ...actionItemColumns, actionedCheckboxColumn, actionedByColumn, actionedDateColumn, closedCheckboxColumn, closedByColumn, closedDateColumn];
    }

    handleSelectedCheckbox(queue) {
        this.setState(prevState => ({
            items: prevState.items.map((item, index) => index === queue.index ? { ...item, selected: !item.selected } : item)
        }));
    }

    async handleAllSelectedCheckbox() {
        await this.setState(prevState => ({ allSelected: !prevState.allSelected }));
        this.setState(prevState => ({
            items: prevState.items.map(item => ({ ...item, selected: prevState.allSelected }))
        }));
    }

    async handleActionedCheckbox(queue) {
        let updatedQueueItem = Object.assign({}, this.state.items[queue.index]);

        updatedQueueItem.actioned_date = (updatedQueueItem.actioned_date === null) ? new Date().toISOString() : null;
        updatedQueueItem.actioned_by = (updatedQueueItem.actioned_by === null) ? this.state.user : null;

        await this.updateRecord(queue.index, updatedQueueItem);
    }

    async handleClosedCheckbox(queue) {
        let updatedQueueItem = Object.assign({}, this.state.items[queue.index]);

        updatedQueueItem.closed_date = (updatedQueueItem.closed_date === null) ? new Date().toISOString() : null;
        updatedQueueItem.closed_by = (updatedQueueItem.closed_by === null) ? this.state.user : null;

        await this.updateRecord(queue.index, updatedQueueItem);
    }

    async updateRecord(queueIndex, updatedQueueItem) {
        let response = null;
        const errorMessage = 'Unable to update status.';

        try {
            response = await API.put("colin", `/proofing/queues/${updatedQueueItem.queue_id}`, { body: updatedQueueItem });
        } catch {
            alert(errorMessage);
            return;
        }

        if (response.result === false) {
            alert(errorMessage);
            return;
        }

        this.setState(prevState => ({
            items: prevState.items.map((item, index) => index === queueIndex ? updatedQueueItem : item)
        }));
    }

    async handleBulkAction(action) {
        // More human-friendly strings
        const actions = {
            action: 'Action',
            unaction: 'Un-Action',
            close: 'Close',
            reopen: 'Re-Open'
        };
        const proceed = window.confirm(`Are you sure you want to ${actions[action]} all ${this.state.items.length} item(s)?`);

        if (!proceed) {
            return;
        }

        let response = null;
        const errorMessage = `Unable to ${actions[action]}.`;

        try {
            response = await API.post("colin", `/proofing/queues/update_bulk`, { 
                body: {
                    queue_type_id: this.state.items[0].queue_type_id,
                    action: action,
                    user_name: this.state.user
                }
            });
        } catch {
            alert(errorMessage);
            return;
        }

        if (response.result === false) {
            alert(errorMessage);
            return;
        }

        const items = [...this.state.items];

        // It's repetitive but it saves us making another API call
        for (const item of items) {
            if (action === 'action') {
                item.actioned_date = new Date().toISOString();
                item.actioned_by = this.state.user;
            } else if (action === 'unaction') {
                item.actioned_date = null;
                item.actioned_by = null;
            } else if (action === 'close') {
                item.closed_date = new Date().toISOString();
                item.closed_by = this.state.user;
            } else if (action === 'reopen') {
                item.closed_date = null;
                item.closed_by = null;
            }
        }

        this.setState({ items });
    }

    render() {
        return (
            <Card>
                <Card.Header>
                    <Accordion.Toggle as={Button} variant="link" eventKey={this.state.id}>
                        <Card.Title>
                            {this.state.name}:  Fail results: {this.state.items.length > 0 ? <font color="red">{this.state.items.length}</font>: 0}
                        </Card.Title>
                    </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey={this.state.id}>
                    <Card.Body>
                        <p>{this.state.description}</p>
                        {false &&
                        <Form.Group as={Row} controlId="bulk_actions" className="ml-1 mb-2">
                            <Button variant="secondary" onClick={this.handleBulkAction.bind(this, 'action')}>Action All</Button>&nbsp;
                            <Button variant="secondary" onClick={this.handleBulkAction.bind(this, 'unaction')}>Un-Action All</Button>&nbsp;
                            <Button variant="secondary" onClick={this.handleBulkAction.bind(this, 'close')}>Close All</Button>&nbsp;
                            <Button variant="secondary" onClick={this.handleBulkAction.bind(this, 'reopen')}>Re-Open All</Button>
                        </Form.Group>
                        }
                        {this.state.items.length > 0 && 
                        <ReactTable
                            data={this.state.items}
                            columns={this.getTableColumns()}
                            defaultPageSize={10}
                            sortable={true}
                        />
                        }
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        );
    }
}